import React from 'react';
import { KTIcon } from '../_4threal/helpers';
import toast, { ToastPosition } from 'react-hot-toast';
// import { Button } from 'react-bootstrap';

export const generatePopup = (type, msg, position: ToastPosition = 'top-center', id: string = 'basic-popup') => {
    // const duration = 10000;
    if (type === 'success') {
        return toast.success((t) => (
            <div 
                id={id} 
                className='d-flex align-items-center gap-3'
                style={{
                    background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                    color: 'white',
                    padding: '12px 16px',
                    borderRadius: '15px',
                    boxShadow: '0 5px 20px rgba(67, 233, 123, 0.3)',
                    fontSize: '14px',
                    fontWeight: '600',
                    minWidth: '300px',
                    width: '100%',
                    border: 'none'
                }}
            >
                <div style={{ flex: 1 }}>
                    {msg}
                </div>
                <div>
                    <button 
                        onClick={() => toast.dismiss(t.id)} 
                        style={{
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            borderRadius: '8px',
                            color: 'white',
                            width: '24px',
                            height: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                            const target = e.target as HTMLElement;
                            target.style.background = 'rgba(255, 255, 255, 0.3)';
                            target.style.transform = 'scale(1.1)';
                        }}
                        onMouseOut={(e) => {
                            const target = e.target as HTMLElement;
                            target.style.background = 'rgba(255, 255, 255, 0.2)';
                            target.style.transform = 'scale(1)';
                        }}
                    >
                        <i style={{color: 'white'}} className='fs-6 bi bi-x-lg' />
                    </button>
                </div>
            </div>
        ), {duration: 7000});
    } else {
        return toast.error((t) => (
            <div 
                id={id} 
                className='d-flex align-items-center gap-3'
                style={{
                    background: 'linear-gradient(135deg, #ff6b6b 0%, #f5576c 100%)',
                    color: 'white',
                    padding: '12px 16px',
                    borderRadius: '15px',
                    boxShadow: '0 5px 20px rgba(255, 107, 107, 0.3)',
                    fontSize: '14px',
                    fontWeight: '600',
                    minWidth: '300px',
                    border: 'none'
                }}
            >
                <div style={{ flex: 1 }}>
                    {msg}
                </div>
                <div>
                    <button 
                        onClick={() => toast.dismiss(t.id)} 
                        style={{
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            borderRadius: '8px',
                            color: 'white',
                            width: '24px',
                            height: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                            const target = e.target as HTMLElement;
                            target.style.background = 'rgba(255, 255, 255, 0.3)';
                            target.style.transform = 'scale(1.1)';
                        }}
                        onMouseOut={(e) => {
                            const target = e.target as HTMLElement;
                            target.style.background = 'rgba(255, 255, 255, 0.2)';
                            target.style.transform = 'scale(1)';
                        }}
                    >
                        <i style={{color: 'white'}} className='fs-6 bi bi-x-lg' />
                    </button>
                </div>
            </div>
        ), {duration: 7000, position: position});
    }
};